import { Dialogs } from '@ionic-native/dialogs/ngx';
import { TranslationService } from 'src/i18n/translation-service';
import { AfterViewInit, Component, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Storage } from '@ionic/storage-angular';
import {
  MenuController,
  NavController,
  Platform,
  ToastController,
  IonicModule,
  ModalController,
  AlertController,
} from '@ionic/angular';
import { SignInPage } from './pages/sign-in/sign-in.page';
import { Observable, Subscription } from 'rxjs';
import {
  ClubInfo,
  PlayerHomeInfo,
  PlayerInfo,
  createClubInfo,
  ClubDataLite,
} from 'src/data/mygolf.data';
import { StatusBar } from '@ionic-native/status-bar/ngx';
// import { Network } from '@ionic-native/network/ngx';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { SplashScreen as splashScreen } from '@capacitor/splash-screen';
import { App } from 'ionic';
import { PlayerHomeActions, PlayerHomeDataService } from 'src/redux/player-home';
import { SessionDataService } from 'src/redux/session';
import { ServerInfoService } from 'src/providers/serverinfo-service/serverinfo-service';
import { ClubFlightService } from 'src/providers/club-flight-service/club-flight-service';
import { ServerInfo } from 'src/data/server-info';
import { filter, map, take } from 'rxjs/operators';
import { MessageDisplayUtil } from 'src/message-display-utils';
import { setChartDefaults } from 'src/charts/chart-globals';
import { TranslateService } from '@ngx-translate/core';
import { Location } from '@angular/common';
import * as global from '../globals';
import { mygolfUtils } from 'src/custom/mygolf2u-utils';
import { CurrentUser, SessionInfo } from 'src/data/authentication-info';
import {
  SUBSCRIBE_EWALLET_TOPUP,
  SUBSCRIBE_EWALLET_TRANSACTION,
  WebsocketActions,
} from 'src/redux/wstomp';
import { NavigationEnd, NavigationExtras, Router } from '@angular/router';
import { App as CapacitorApp } from '@capacitor/app';
import { register } from 'swiper/element/bundle';

import * as moment from 'moment';
import { PermissionsService } from 'src/providers/permission-service';
import { DynamicImportService } from 'src/providers/dynamic-import-scss/dynamic-import-scss';

import { Network } from '@capacitor/network';
import { ConnectionService } from 'src/providers/connection-service/connection-service';

register();
// import { App as CapacitorApp } from '@capacitor/app';
@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class MyApp implements AfterViewInit {
  @ViewChild(NavController) nav: NavController;
  labels = {};

  // make HelloIonicPage the root (or first) page
  rootPage: any = SignInPage;
  pages: Array<{ title: string; component: any }>;

  private disconnectSubscriber: Subscription;
  // private connectSubscriner: Subscription;

  public playerHomeInfo$: Observable<PlayerHomeInfo>;
  public player$: Observable<PlayerInfo>;

  showLogin: boolean;
  loggedIn: boolean = false;

  isBookingRegistrationEnabled: boolean;
  clubSpecificThemes;

  ewalletTopupSub: Subscription;
  ewalletTrxnSub: Subscription;
  spinnerLoaderDelay: number = 5000;

  _register: any;
  _compRegister: any;
  constructor(
    public platform: Platform,
    private Location: Location,
    public menu: MenuController,
    public toastCtl: ToastController,
    public statusBar: StatusBar,
    // public network: Network,
    // public dialogs: Dialogs,
    private dialogs: Dialogs,
    public splashScreen: SplashScreen,
    //  public app1: IonApp,
    // public _ionicApp: IonicApp,
    public playerHomeService: PlayerHomeDataService,
    private sessionDataService: SessionDataService,
    private serverInfoService: ServerInfoService,
    private flightService: ClubFlightService,
    private translate: TranslateService,
    private translationCustomService: TranslationService,
    private mg2uUtil: mygolfUtils,
    private websocketActions: WebsocketActions,
    private playerHomeActions: PlayerHomeActions,
    private router: Router,
    private mg2uUtils: mygolfUtils,
    private modalCtl: ModalController,
    private alertCtrl: AlertController,
    private permissionsService: PermissionsService,
    private dynamicImportService: DynamicImportService,
    private networkService: ConnectionService
  ) {
    this.setupConnectionHandlers();

    // this.initCheckPermissions();
    let _consoleParam = this.platform.getQueryParam('showConsole');

    if (this.platform.getQueryParam('spinnerLoaderDelay'))
      this.spinnerLoaderDelay = Number(this.platform.getQueryParam('spinnerLoaderDelay'));
    if (global.environment && global.environment.includes('prod') && !_consoleParam) {
      console.warn(`? There is nothing to look at here`);
      console.log = function (): void {};
      console.debug = function (): void {};
      console.warn = function (): void {};
      console.info = function (): void {};
    }

    this._register = this.platform.getQueryParam('register');
    this._compRegister = this.platform.getQueryParam('compRegister');
    this.initializeApp();

    this.mg2uUtils.getWebParams();
    this.setInitLanguage(this.translationCustomService.getLanguage());
    // enablePlayerAppBooking
    this.serverInfoService.serverInfo().subscribe((data: ServerInfo) => {
      if (data) {
        this.isBookingRegistrationEnabled = data.enablePlayerAppBooking;
      }
    });

    platform.ready().then(() => {
      if (this.platform.is('capacitor')) this.OneSignalInit();

      this.getAppAttribute();
      this.getAppRoleAccess();
      this.websocketActions.configure();
      // Do your thing...
      if (!this.platform.is('capacitor')) this.setupBackButtonBehavior();

      // this.getHomeAttribute();
    });

    // set our app's pages
    this.pages = [];
    this.playerHomeInfo$ = this.playerHomeService.playerHomeInfo();
    this.player$ = this.playerHomeInfo$.pipe(
      filter(Boolean),
      map((playerHome: PlayerHomeInfo) => playerHome.player)
    );
    let _playerId = null;

    let _param = Number(this.platform.getQueryParam('param'));

    if (_param) {
      this.mg2uUtil.setClubSpecific(true);
      this.mg2uUtil.setClubId(_param);
      this.flightService.getClubInfo(_param).subscribe((data: ClubDataLite) => {
        this.mg2uUtil.setSelectedClub(data);
        this.mg2uUtil.setClubParam(true);
        // this.nav.setRoot(PlayerHomePage,{
        //     useParam: true
        // })
      });
    }

    this.sessionDataService
      .getSession()
      .pipe(take(1))
      .subscribe(
        (session: SessionInfo) => {
          if (session && session.password) {
          } else {
          }
        },
        error => {}
      );

    this.ewalletTopupSub = this.websocketActions
      .subscribeTo(SUBSCRIBE_EWALLET_TOPUP)
      .subscribe((data: any) => {
        this.player$.pipe(take(1)).subscribe(player => {
          _playerId = player.playerId;
        });
        if (data && data.playerId === _playerId) {
          this.getEwalletMessage(data, 'topup');
        }
      });

    this.ewalletTrxnSub = this.websocketActions
      .subscribeTo(SUBSCRIBE_EWALLET_TRANSACTION)
      .subscribe((data: any) => {
        this.player$.pipe(take(1)).subscribe(player => {
          _playerId = player.playerId;
        });

        if (data && data.playerId === _playerId) {
          this.getEwalletMessage(data, 'transaction');
        }
        // if(data && data.clubId === )
      });
  }

  ngAfterViewInit() {
    const splashScreen = document.getElementById('custom-splash-screen');
    setTimeout(() => {
      if (splashScreen) {
        splashScreen.style.display = 'none';
      }
    }, this.spinnerLoaderDelay);

    this.platform.ready().then(() => {
      this.loadURLParams();
    });
  }

  public pageRoleAccess: Array<any>;
  getAppRoleAccess() {
    this.flightService.getAppRoleAccess().subscribe((data: any) => {
      if (data) {
        this.pageRoleAccess = data;
      }
    });
  }

  OneSignalInit(): void {
    // // Uncomment to set OneSignal device logging to VERBOSE
    // // OneSignal.setLogLevel(6, 0);
    // // NOTE: Update the setAppId value below with your OneSignal AppId.
    // OneSignal.setAppId("8a23eb44-fcac-4899-a4e4-2ce8fbd9851a");
    // OneSignal.setNotificationOpenedHandler(function(jsonData) {
    // });
    // // Prompts the user for notification permissions.
    // //    * Since this shows a generic native prompt, we recommend instead using an In-App Message to prompt for notification permission (See step 7) to better communicate to your users what notifications they will get.
    // OneSignal.promptForPushNotificationsWithUserResponse(function(accepted) {
    // });
  }

  checkName() {
    // let activePortal = this.nav.getActive();
    // let _msg = activePortal.component.name;
    let _msg = '';
    MessageDisplayUtil.showMessageToast(_msg, this.platform, this.toastCtl, 3000, 'bottom');
  }

  private setupBackButtonBehavior() {
    console.debug('set up back button ');
    this.backButtonSubscription = this.platform.backButton.subscribeWithPriority(9999, async () => {
      const modal = await this.modalCtl.getTop();
      console.debug('set up back button ', modal);
      if (modal) {
        modal.dismiss();
        // If a modal is open, prevent default back button behavior
        return;
      }

      // Your existing back button logic for non-modal cases
      // const currentUrl = this.router.url;
      // if (currentUrl === '/home') {
      //   // Handle exit confirmation
      //   // this.showExitConfirmation();
      // } else {
      //   // this.location.back();
      // }
    });

    // Handle popstate for browser back button
    // window.history.pushState(null, '', window.location.href);
    window.onpopstate = async () => {
      const modal = await this.modalCtl.getTop();
      if (modal) {
        console.debug('modal ', modal);
        modal.dismiss();
        // If a modal is open, prevent navigation
        // window.history.pushState(null, '', window.location.href);
        return;
      }

      // Your existing popstate logic for non-modal cases
      // ...
    };
    // If on web version (browser)
    // if (window.location.protocol !== "file:") {

    //   // Register browser back button action(s)
    //   window.onpopstate = (evt) => {

    //     // Close menu if open
    //     if (this.menu.isOpen()) {
    //       this.menu.close();
    //       return;
    //     }

    //     // Close any active modals or overlays
    //     //comment
    //     // let activePortal = this._ionicApp._loadingPortal.getActive() ||
    //     //   this._ionicApp._modalPortal.getActive() ||
    //     //   this._ionicApp._toastPortal.getActive() ||
    //     //   this._ionicApp._overlayPortal.getActive();

    //     // if (activePortal) {
    //     //   activePortal.dismiss();
    //     //   return;
    //     // }

    //     // Navigate back
    //     // if (this.app.getRootNav().canGoBack()) this.app.getRootNav().pop();

    //   };

    //   // // Fake browser history on each view enter
    //   // this.app.viewDidEnter.subscribe((app) => {
    //   //   history.pushState(null, null, "");
    //   // });

    // }
  }

  private getEwalletMessage(data, type) {
    let _action = '';
    let _msg = '';
    let _clubName = '';
    let _currency = '';
    let _amount = 0;

    switch (type) {
      case 'topup':
        if (data.action === 'topUp') _action = 'Added New Top Up';
        else if (data.action === 'topUpUpdate') _action = 'Updated Top Up';
        else if (data.action === 'topUpDelete') _action = 'Deleted Top Up';
        _amount = this.mg2uUtil.numberWithCommas(data.amount);
        // if(data.amount) _amount = data.amount;

        this.getClubInfo(data.clubId)
          .then((result: any) => {
            if (result.status === 'success') {
              _clubName = result.clubInfo.clubTag;
              _currency = result.clubInfo.country.currencySymbol;
              _msg =
                data.topUpByName +
                ' from ' +
                _clubName +
                ' has successfully ' +
                _action +
                ' for amount of ' +
                _currency +
                ' ' +
                _amount;

              this.playerHomeActions.setNeedRefresh(true);
              this.playerHomeActions.refreshHomeInfo();
              MessageDisplayUtil.showMessageToast(
                _msg,
                this.platform,
                this.toastCtl,
                15000,
                'bottom'
              );
            }
          })
          .catch(error => {
            _msg = 'Succesfully ' + data.action + ' for amount of ' + _amount;
            MessageDisplayUtil.showMessageToast(_msg, this.platform, this.toastCtl, 5000, 'bottom');
          });
        break;
      case 'transaction':
        let _expType = 'Miscellaneous';
        let _outletName = '';
        let _trxnDate = '';

        let _totalAmount = 0;

        if (data.action === 'transactions') _action = 'deducted';
        else if (data.action === 'undoTransaction') _action = 'Undo a Transaction';

        let _trxnDetails = [];
        _trxnDetails.push(...data.transactions);
        this.getClubInfo(data.clubId)
          .then((result: any) => {
            if (result.status === 'success') {
              _clubName = result.clubInfo.clubTag;
              _currency = result.clubInfo.country.currencySymbol;

              if (data.action === 'transactions') {
                _expType = _trxnDetails[0].expenditureType;
                _outletName = _trxnDetails[0].outletName;
                _trxnDate = _trxnDetails[0].transactionDate;
                _totalAmount = _trxnDetails
                  .map(trxn => {
                    return trxn.amount;
                  })
                  .reduce((a, b) => {
                    return a + b;
                  }, 0);
              } else if (data.action === 'undoTransaction') {
                _totalAmount = data.amount;
                _expType = data.expenditureType;
                _outletName = data.outletName;
                _trxnDate = data.transactionDate;
              }
              _totalAmount = this.mg2uUtil.numberWithCommas(_totalAmount);

              _msg =
                '[' +
                _outletName +
                ' - ' +
                _expType +
                '] ' +
                _trxnDate +
                ' - Successfully ' +
                _action +
                ' amount of ' +
                _currency +
                ' ' +
                _totalAmount;
              // _msg = data.topUpByName + ' from ' + _clubName + ' has successfully ' + _action + ' for amount of '+ _currency+ ' ' + _amount;
              // _msg = "Successfully "+_action+ " amount of "+_currency+' '+ _totalAmount + " for "+_outletName + " on "+_trxnDate;

              this.playerHomeActions.setNeedRefresh(true);
              this.playerHomeActions.refreshHomeInfo();
              MessageDisplayUtil.showMessageToast(
                _msg,
                this.platform,
                this.toastCtl,
                15000,
                'bottom'
              );
            }
          })
          .catch(error => {
            // _msg = 'Succesfully ' + _action + ' for amount of ' + _amount;
            // MessageDisplayUtil.showMessageToast(_msg,
            //     this.platform, this.toastCtl, 5000, "bottom");
          });
        break;
    }
  }

  clubInfo: any;
  getClubInfo(clubId: number) {
    return new Promise((resolve, reject) => {
      if (!clubId) {
        reject({
          status: 'failed',
          message: 'No Club Id provided',
        });
      } else if (clubId) {
        this.flightService.getClubInfo(clubId).subscribe((data: ClubInfo) => {
          if (data) {
            resolve({
              status: 'success',
              message: 'club info',
              clubInfo: data,
            });
          }
        });
      }
    });
  }
  loadDynamicStylesheet() {
    const url = `${global.MygolfServer}/document/assets/themes.css`;
    this.dynamicImportService.loadStylesheet(url);
  }
  initializeApp() {
    this.loadDynamicStylesheet();
    this.platform.ready().then(() => {
      // // Force consistent text sizing
      // document.body.style.fontSize = '16px';

      // // Prevent zoom on iOS
      // if (this.platform.is('ios')) {
      //   document.addEventListener('gesturestart', e => {
      //     e.preventDefault();
      //   });
      // }
      this.initCheckPermissions();
      if (!this.mg2uUtils.getPref('communalMode')) {
        this.mg2uUtils.setPref('communalMode', true);
      }

      // Handle app state changes
      CapacitorApp.addListener('appStateChange', ({ isActive }) => {
        if (isActive) {
          // App has come to foreground
          this.handleAppResume();
        } else {
          // App has gone to background
          this.handleAppPause();
        }
      });

      history.pushState(null, '');
      //     let _register = this.platform.getQueryParam('register');
      //     let _compRegister = this.platform.getQueryParam('compRegister');
      //     if (_register && _register === 'true') {
      //       this.sessionDataService.showLoginForm().subscribe((show: boolean) => {
      //         this.showLogin = show;

      //         if (show) {
      //           this.sessionDataService.getCurrentUser()
      //             .subscribe((currUser: CurrentUser) => {
      //               // this.username.setValue(currUser.userName);
      //             });
      //             this.router.navigate(['sign-up']);
      //         } else {

      //         }

      //       });
      //       // this.nav.setRoot(SignUp, {
      //       //   useParam: true
      //       // })
      //       // this.mg2uUtil.goToHome();
      //       // this.nav.popToRoot();
      //       return;
      //     }

      //     if(!!_compRegister && Number(_compRegister) > 0) {

      //       this.sessionDataService.showLoginForm().subscribe((show: boolean) => {
      //         this.showLogin = show;

      //         if (show) {
      //           this.sessionDataService.getCurrentUser()
      //             .subscribe((currUser: CurrentUser) => {
      //             });
      //             this.router.navigate(['sign-up']);
      //         } else {
      //           this.getCompetitionData(Number(_compRegister))
      //           .then((result: any)=>{
      //             console.debug("get comp data", Number(_compRegister), result);
      //             let navigationExtras: NavigationExtras = {
      //               state: {
      //                 competition: result,
      //                 compId: result?.id,
      //                 animate: false,
      //               },
      //             };
      //             this.router.navigate(['competition-details'], navigationExtras);
      //           }).catch((error)=>{
      //             if(error === true) {
      //                 MessageDisplayUtil.showErrorToast("There is no competition with this id",
      //                 this.platform, this.toastCtl, 3000, 'bottom');
      //             } else {
      //               let _message = 'There is no competition with this id';
      //               if(error?.errorMessage) _message = error?.errorMessage;
      //               MessageDisplayUtil.showErrorToast(_message,
      //               this.platform, this.toastCtl, 3000, 'bottom');
      //             }
      //           })
      //         }

      //       });
      //     }
      setChartDefaults();
      // Okay, so the platform is ready and our plugins are available.
      // Here you can do any higher level native things you might need.
      this.statusBar.styleDefault();
      this.statusBar.show();
      this.statusBar.overlaysWebView(false);
      this.statusBar.backgroundColorByHexString('#71be72');
      // this.statusBar.overlaysWebView(true);
      // StatusBar.hide();
      this.hideSplashScreen();
      // this.platform.backButton.subscribeWithPriority(101, () => {

      //comment navigate to previosu page or exit app
      // let nav = this.app.getRootNav();
      // let activeNav = this.app.getActiveNav();
      // if (nav === activeNav && nav.getActive() && nav.getActive().isFirst())
      //   this.confirmAndExit(nav);
      // else
      //   this.app.navPop();

      // });
      CapacitorApp.addListener('backButton', ({ canGoBack }) => {
        console.log('on back button', canGoBack);
        if (!canGoBack) {
          CapacitorApp.exitApp();
        } else {
          window.history.back();
        }
      });
      // this.platform.backButton.subscribeWithPriority(0, (processNextHandler) => {
      //   // this.Location.back();
      //   console.log("on back button - platorm" );
      //   console.log("on back button - platorm", this.router.getCurrentNavigation().extractedUrl);

      // });

      // this.disconnectSubscriber = this.network.onDisconnect()
      //   .subscribe(() => {
      //     MessageDisplayUtil.showErrorToast("You have lost your data connection.",
      //       this.platform, this.toastCtl, 3000, 'bottom');

      //   });

      if (global.appType === 'club' && global.clubId === 310510386) {
        this.updateColor('gold');
      } else this.updateColor(null, true);
    });

    this.platform.ready().then(() => {
      // CapacitorApp.addListener('backButton', ({canGoBack}) => {
      //   if(!canGoBack){
      //     CapacitorApp.exitApp();
      //   } else {
      //     window.history.back();
      //   }
      // });
      // document.addEventListener('backbutton', () => {
      //   console.log("on back button - document " )
      //   //
      //   //  if (this.navCtrl.canGoBack()) {
      //   //    this.platform.exitApp()
      //   //    return;
      //   //  }
      //   //  this.navCtrl.pop()
      // }, false);
    });

    // this.sessionDataService.showLoginForm().subscribe((show: boolean) => {
    //     this.showLogin = show;
    //     if (show) {
    //         // this.sessionDataService.getCurrentUser()
    //         //     .subscribe((currUser: CurrentUser) => {
    //         //         this.username.setValue(currUser.userName);
    //         //     });
    //     }

    // });

    this.sessionDataService.getSessionStatus().subscribe((data: any) => {
      //
      if (data === 1) this.loggedIn = true;
      else if (data === 3) this.loggedIn = false;
      else this.loggedIn = false;
    });

    this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe(event => {
      this.onPageChange(event);
    });
  }

  openPage(page) {
    // close the menu when clicking a link from the menu
    this.menu.close();

    // navigate to the new page if it is not the current page
    // this.nav.push(page.component);
  }

  confirmAndExit(nav: NavController) {
    if (this.platform.is('capacitor')) {
      //

      this.dialogs
        .confirm('Do you want to exit myGolf2u ?', 'Exit App', ['No', 'Exit'])
        .then((result: any) => {
          if (result && result === 2) {
            // this.platform.exitApp();
            navigator['app'].exitApp();
          }
        });
    }
  }

  hideSplashScreen() {
    // if (splashScreen) {
    setTimeout(() => {
      splashScreen.hide();
    }, 1000);
    // }
  }

  onHomeClick() {
    if (this.disableFooterPage(3)) return false;
    //
    // this.nav.popToRoot();//this.nav.setRoot(PlayerHomePage);
  }

  openProfile() {
    if (this.disableFooterPage(5)) return false;
    // this.nav.push(ProfilePage, {
    //   type: 'playerProfile',
    //   player: this.player$
    // });
    let params: NavigationExtras = {
      replaceUrl: true,
      state: {
        type: 'playerProfile',
        player: this.player$,
      },
    };
    this.router.navigate(['tabs/profile'], params);
  }

  onMyBookingsClick() {
    // console.debug("on my bookings click")
    if (this.disableFooterPage(1)) return false;
    if (!this.isBookingRegistrationEnabled) {
      MessageDisplayUtil.showErrorToast(
        'Booking & Registration feature will be coming soon.',
        this.platform,
        this.toastCtl,
        3000,
        'bottom'
      );
      return false;
    }

    // if(this.fromClub) this.nav.push(BookingCalendarPage , {clubId: _clubId})
    // else this.nav.push(BookingHomePage);
    // this.nav.push(BookingHomePage);

    let _isClubSpecific: boolean = false;
    let _club: ClubInfo;
    _club = createClubInfo();
    if (global.appType === 'club' && global.clubId) {
      _isClubSpecific = true;
      this.mg2uUtil.setClubSpecific(true);
      // _club['clubId'] = global.clubId
      this.flightService.getClubInfo(global.clubId).subscribe((club: ClubInfo) => {
        if (club) {
          _club = club;
          let params: NavigationExtras = {
            replaceUrl: true,
            state: {
              userType: 'player',
              isClubSpecific: _isClubSpecific,
              club: _club,
              clubSpecificThemes: this.clubSpecificThemes,
            },
          };
          this.router.navigate(['booking-home'], params);
        }
      });
    } else {
      if (this.mg2uUtil.getSelectedClub()) this.mg2uUtil.setClubSpecific(true);
      else this.mg2uUtil.setClubSpecific(false);
      let params: NavigationExtras = {
        replaceUrl: true,
        state: {
          userType: 'player',
          isClubSpecific: _isClubSpecific,
          club: this.mg2uUtil.getSelectedClub() ? this.mg2uUtil.getSelectedClub() : _club,
          clubSpecificThemes: this.clubSpecificThemes,
        },
      };
      this.router.navigate(['booking-home'], params);
    }
  }

  onFAQClick() {
    if (this.disableFooterPage(4)) return false;
    if (global.appType === 'club' && global.clubId) return false;
    this.router.navigate(['tabs/faq']);
  }

  onNotificationsClick() {
    if (this.disableFooterPage(2)) return false;
    if (this.appAttribute && !this.appAttribute.enableNotfPage && global.appType === 'club') {
      let _msg = 'This feature will be coming soon.';
      if (this.appAttribute && !this.appAttribute.errorNotfMessage)
        _msg = this.appAttribute.errorNotfMessage;
      MessageDisplayUtil.showErrorToast(_msg, this.platform, this.toastCtl, 3000, 'bottom');
      return;
    }
    this.router.navigate(['tabs/notifications']);
  }

  showFooterPage() {
    enum pageToExclude {
      'SetupPlayingCoursesPage',
      'FlightSetupPage',
      'CompetitionPlayersPage',
      'PlayerMg2uCreditsModal', //n4-4
      'RefundBookingPlayersModal',
      'CaddyScheduleDisplayPage',
      'ClubBookingListPage',
      'BookingCalendarPage',
    }

    let _showFooter = true;

    //commnet
    // let viewAll = this.nav.getAllChildNavs();
    // let activePortal = this.nav.getActive();
    // let name = activePortal.component.name;
    // let activeView = this.nav.getActive();

    //  if (activeView && activeView.instance && activeView.instance.appFooterHide) _showFooter = false;

    // this.nav.viewDidEnter.subscribe(item => {
    //   const viewController = item as ViewController;
    //   const n = viewController.name;
    //   name = viewController.name;
    //   const id = viewController.id;
    // });

    // for (let value in pageToExclude) {
    //   if (name.toLowerCase().includes(value.toLowerCase())) {
    //     _showFooter = false;
    //     continue;
    //   }
    // }

    return _showFooter;
  }

  disableFooterPage(type?: number) {
    let _disableFooter = false;

    //comment
    // let activePortal = this.nav.getActive();
    // let name = activePortal.component.name;

    let name = '';

    if (type === 1) {
      //mybookings
      if (name === 'BookingHomePage') _disableFooter = true;
    } else if (type === 2) {
      //notifications
      if (name === 'NotificationsPage') {
        _disableFooter = true;
      }
      // NotificationsPage
    } else if (type === 3) {
      //home
      if (name === 'PlayerHomePage') {
        _disableFooter = true;
      }
      // BookingHomePage
    } else if (type === 4) {
      //FAQ
      if (name === 'FaqPage') _disableFooter = true;
      // FaqPage
    } else if (type === 5) {
      //profile
      if (name === 'ProfilePage') _disableFooter = true;
    }

    return _disableFooter;
  }

  appAttribute: any;
  showConsoleLog: boolean = false;
  getAppAttribute() {
    this.flightService.getAppAttributes().subscribe(
      (data: any) => {
        if (data) {
          data
            .filter(d => {
              return d.page === 'mainApp';
            })
            .map(d => {
              this.appAttribute = d;
            });

          data
            .filter(theme => {
              return theme.page === 'playerHome';
            })
            .map(theme => {
              this.clubSpecificThemes = theme.clubSpecificThemes;
              if (theme && theme.clubSpecificThemes)
                theme.clubSpecificThemes.filter(club => {
                  if (global.appType === 'club' && global.clubId === club.clubId) {
                    this.updateColor(club.themeName);
                  }
                });
            });
          if (this.appAttribute) {
            if (this.appAttribute.showConsoleLog)
              this.showConsoleLog = this.appAttribute.showConsoleLog;
          }
        }
      },
      error => {},
      () => {
        if (!this.showConsoleLog) {
        }
      }
    );
  }

  setInitLanguage(lang) {
    //
    this.translate.currentLang = lang;
    this.translationCustomService.changeLanguage(lang);
    this.translate
      .get([
        'USER_NOT_LOGGED_IN',
        'LOGOUT_TITLE',
        'LOGOUT_DESCRIPTION',
        'YES',
        'NO',
        'EXIT_APPLICATION',
        'EXIT_CONFIRMATION',
      ])
      .subscribe(res => {
        for (let key in res) {
          this.labels[key] = res[key];
        }
      });
  }

  updatedColor: number = 0;

  getSVGImageClass(additionalClass: string) {
    if (this.updatedColor > 0) return additionalClass + ' ' + 'svg-filter';
    else return additionalClass;
  }

  updateColor(themeName?: string, reset?: boolean) {
    // document.documentElement.style.setProperty(`--color`, color);

    if (themeName) document.body.className = 'theme-' + themeName;
    else document.body.className = '';
    // .toggle(color);
    // document.documentElement.style.setProperty(`--ion-border-color`, color);
  }

  backButtonSubscription: Subscription;
  ngOnDestroy() {
    if (this.backButtonSubscription) {
      this.backButtonSubscription.unsubscribe();
    }
    this.doneShowMaintenance = false;
    Network.removeAllListeners();
    this.websocketActions.closeConnection();
  }

  getHomeAttribute() {
    return new Promise((resolve, reject) => {
      let _appAttribute;
      this.flightService.getAppAttributes().subscribe((data: any) => {
        if (data) {
          this.mg2uUtil.setAppAttributes(data);
          data
            .filter(d => {
              return d.page === 'playerHome';
            })
            .map(d => {
              _appAttribute = d;
            });

          if (_appAttribute) {
            resolve({
              appAttribute: _appAttribute,
              maintenance: _appAttribute.maintenance,
              announcement: _appAttribute.announcement,
            });
            // // let _maintenance = this.appAttribute.maintenance;
            // if (_appAttribute.maintenance) {
            //   resolve({
            //     appAttribute: _appAttribute,
            //     maintenance: _appAttribute.maintenance
            //   })
            //   // this.displayMaintenance(_appAttribute);
            // }
            // // let _announcement = this.appAttribute.annoucement;
            // if (_appAttribute.announcement) {
            //   resolve({
            //     appAttribute: _appAttribute,
            //     announcement: _appAttribute.announcement
            //   })
            //   // this.displayAnnouncement(this.appAttribute);
            // }
          }
        }
      });
    });
  }

  doneShowMaintenance: boolean = false;
  async displayMaintenance(appAttribute) {
    if (this.doneShowMaintenance) return;
    if (!appAttribute) return false;
    let _maintenance = appAttribute.maintenance;
    let _fromDate = _maintenance.fromDate;
    let _daysBefore = _maintenance.daysBefore;
    let _dateBefore;
    if (_daysBefore) _dateBefore = moment(_fromDate).add(-1 * _daysBefore, 'days');
    let _toDate = _maintenance.toDate;
    // if(_daysBefore) _dateBefore = moment(_toDate).add(-1*_daysBefore, "days");
    let _fromTime = _maintenance.fromTime;
    let _toTime = _maintenance.toTime;

    let _fromDateTime = moment(_fromDate + _fromTime, 'YYYY-MM-DDHH:mm');
    // moment(_dateBefore).format("YYYY-MM-DD")

    let _toDateTime = moment(_toDate + _toTime, 'YYYY-MM-DDHH:mm');
    if (_maintenance.showMaintenanceMessage) {
      this.doneShowMaintenance = true;
      // let _msg = "Server is currently under maintenance. <br>Scheduled time <br><b>"+moment(_fromDateTime).format("ddd, DD MMM YYYY HH:mm") + "</b> to <b>" + moment(_toDateTime).format("ddd, DD MMM YYYY HH:mm")+"</b>";
      let _msg =
        'The system will be unavailable during the following period : <br><b>' +
        moment(_fromDateTime).format('ddd, DD MMM YYYY HH:mm') +
        '</b> to <br><b>' +
        moment(_toDateTime).format('ddd, DD MMM YYYY HH:mm') +
        '</b>';
      if (_maintenance.maintenanceMessage) {
        _msg =
          _maintenance.maintenanceMessage +
          '<br><b>' +
          moment(_fromDateTime).format('ddd, DD MMM YYYY HH:mm') +
          '</b> to <br><b>' +
          moment(_toDateTime).format('ddd, DD MMM YYYY HH:mm') +
          '</b>';
      }
      let _buttons = [];
      if (
        _maintenance.blockForMaintenance &&
        moment().isBetween(_fromDateTime, _toDateTime, 'minute')
      ) {
        if (this.platform.is('capacitor'))
          _buttons.push({
            text: 'Close',
            role: 'cancel',
            handler: () => {
              if (this.platform.is('capacitor')) _alert.dismiss(true);
              return false;
            },
          });
      } else {
        _buttons.push({
          text: 'Okay',
          role: 'cancel',
          handler: () => {
            _alert.dismiss(false);
            return false;
          },
        });
      }
      let _alert = await this.alertCtrl.create({
        header: 'Server Maintenance',
        message: _msg,
        buttons: _buttons,
        backdropDismiss: _maintenance.blockForMaintenance ? false : true,
      });
      _alert.onDidDismiss().then((exit: any) => {
        if (exit) this.platform.pause;
      });
      // if(moment().isBetween(_fromDate + " " + _fromTime, _toDate + " " + _toTime ))

      // if(moment().isBetween(_fromDateTime, _toDateTime,'minute') ||  moment().isBetween(_dateBefore,moment(_toDate,"YYYY-MM-DD")))
      if (moment().isBetween(_dateBefore, _toDateTime, 'minute')) _alert.present();
      // .endOf('day')
    } else {
      this.doneShowMaintenance = false;
    }
  }

  onPageChange(event) {
    // Example: Log page change
    // console.log('Page changed [0]',event);
    this.getHomeAttribute().then((result: any) => {
      // console.log('Page changed [1]', this.doneShowMaintenance, this.doneShowAnnouncement);
      // console.log('Page changed [2]', result);
      if (result?.maintenance) {
        this.displayMaintenance(result.appAttribute);
      }
      if (result?.announcement) {
        if (event?.url.includes('/player-home') || event?.url.includes('/sign-in')) {
          this.displayAnnouncement(result.appAttribute);
        }
      }
    });
    // Add any other code you need to execute on each page change
  }

  doneShowAnnouncement: boolean = false;
  async displayAnnouncement(appAttribute) {
    console.debug('display announcement - player home', appAttribute);
    if (this.doneShowAnnouncement) return;
    if (!appAttribute) return;
    if (appAttribute?.announcement?.preV5only) return;
    let _announcement = appAttribute.announcement;
    let _fromDate = moment(_announcement.fromDate, 'YYYY-MM-DD');
    let _toDate = moment(_announcement.toDate, 'YYYY-MM-DD');

    if (_announcement.showAnnouncement) {
      this.doneShowAnnouncement = true;
      let _msg = 'Welcome to myGolf2u';
      if (_announcement.announcementMessage) {
        _msg = _announcement.announcementMessage;
      }
      let _buttons = [];
      _buttons.push({
        text: 'Okay',
        role: 'cancel',
        handler: () => {
          _alert.dismiss(false);
          return false;
        },
      });
      let _alert = await this.alertCtrl.create({
        header: 'Announcement',
        message: _msg,
        buttons: _buttons,
      });
      _alert.onDidDismiss().then(exit => {
        if (exit) this.platform.pause;
      });
      if (moment().isBetween(_fromDate, _toDate, 'day', '[]')) _alert.present();
    } else this.doneShowAnnouncement = false;
  }

  getCompetitionData(compId: number) {
    return new Promise((resolve, reject) => {
      if (!compId) reject(true);
      this.flightService.getCompetitionDetails(compId).subscribe(
        compData => {
          resolve(compData);
        },
        error => {
          reject(error);
        }
      );
    });
  }

  loadURLParams() {
    if (this._register && this._register === 'true') {
      this.sessionDataService.showLoginForm().subscribe((show: boolean) => {
        this.showLogin = show;

        if (show) {
          this.sessionDataService.getCurrentUser().subscribe((currUser: CurrentUser) => {});
          this.router.navigate(['sign-up']);
        } else {
        }
      });
      return;
    }

    if (!!this._compRegister && Number(this._compRegister) > 0) {
      this.sessionDataService
        .getSession()
        .pipe(take(1))
        .subscribe(
          (session: SessionInfo) => {
            if (session && session.userId) {
              this.getCompetitionData(Number(this._compRegister))
                .then((result: any) => {
                  // console.debug("get comp data", Number(this._compRegister), result);
                  let navigationExtras: NavigationExtras = {
                    state: {
                      competition: result,
                      compId: result?.id,
                      animate: false,
                    },
                  };
                  this.router.navigate(['competition-details'], navigationExtras);
                })
                .catch(error => {
                  if (error === true) {
                    MessageDisplayUtil.showErrorToast(
                      'There is no competition with this id',
                      this.platform,
                      this.toastCtl,
                      3000,
                      'bottom'
                    );
                  } else {
                    let _message = 'There is no competition with this id';
                    if (error?.errorMessage) _message = error?.errorMessage;
                    MessageDisplayUtil.showErrorToast(
                      _message,
                      this.platform,
                      this.toastCtl,
                      3000,
                      'bottom'
                    );
                  }
                });
            } else {
              this.sessionDataService.getCurrentUser().subscribe((currUser: CurrentUser) => {});
              this.router.navigate(['sign-up']);
              return;
            }
          },
          error => {
            this.sessionDataService.getCurrentUser().subscribe((currUser: CurrentUser) => {});
            this.router.navigate(['sign-up']);
            return;
          }
        );
    }
  }

  removeUrlParam(paramToRemove: string) {
    const currentUrl = this.router.url;
    const urlTree = this.router.parseUrl(currentUrl);

    // Remove specific query parameter
    delete urlTree.queryParams[paramToRemove];

    // Navigate without triggering a route change
    this.router.navigateByUrl(urlTree);
  }

  private handleAppResume() {
    // this.websocketActions.configure();
    setTimeout(() => {
      this.simulateTouchAtCenter();
    }, 750); // Add a small delay to ensure the app is fully visible
    // Get the current URL
    const currentUrl = this.router.url;

    // // Force a refresh of the current route
    // this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
    //   this.router.navigate([currentUrl]);
    // });

    // // Optional: Refresh any data that might be stale
    // this.refreshAppData();
  }

  private handleAppPause() {
    // Save any necessary app state here
    // For example: save form data to localStorage
    // this.saveAppState();
  }

  networkStatus: boolean;
  isConnected: boolean;
  private networkSubscription: Subscription;
  async ngOnInit() {
    // Get initial status
    this.isConnected = this.networkService.getCurrentNetworkStatus();

    // Subscribe to changes
    this.networkSubscription = this.networkService.onNetworkStatusChange().subscribe(connected => {
      console.debug('app comp - network status change', connected);
      this.isConnected = connected;
      this.handleNetworkChange(connected);
    });

    // // Get the current network status
    // const status = await Network.getStatus();
    // this.networkStatus = status.connected;

    // // Listen for network changes
    // Network.addListener('networkStatusChange', status => {
    //   this.networkStatus = status.connected;
    //   console.log('Network status changed:', status.connected, Network.getStatus());
    //   if(status.connected) {
    //     this.websocketActions.configure();
    //     MessageDisplayUtil.showMessageToast('Network connection restored', this.platform, this.toastCtl,
    //     3000, 'bottom')
    //   } else {
    //     MessageDisplayUtil.showErrorToast('Network connection lost', this.platform, this.toastCtl,
    //     3000, 'bottom')
    //   }
    // });
  }
  private handleNetworkChange(connected: boolean) {
    if (connected) {
      console.log('Network is available');
      // this.websocketActions.configure();
      MessageDisplayUtil.showMessageToast(
        'Network connection is restored',
        this.platform,
        this.toastCtl,
        3000,
        'top'
      );
      // Your logic when network becomes available
    } else {
      console.log('Network connection lost');
      MessageDisplayUtil.showErrorToast(
        'Network connection lost',
        this.platform,
        this.toastCtl,
        5000,
        'top'
      );
      // Your logic when network is lost
    }
  }

  async initCheckPermissions() {
    // Example: Request camera and storage permissions
    const permissions = [
      'android.permission.CAMERA',
      // 'android.permission.READ_MEDIA_IMAGES',
      // 'android.permission.READ_MEDIA_VIDEO',
      'android.permission.ACCESS_FINE_LOCATION',
      'android.permission.ACCESS_COARSE_LOCATION',
    ];

    const results = await this.permissionsService.checkMultiplePermissions(permissions);

    results.forEach((granted, permission) => {
      console.log(`Permission ${permission}: ${granted ? 'granted' : 'denied'}`);
    });

    // await Promise.all([
    //   this.permissionsService.checkCameraPermissionRequest(),
    //   this.permissionsService.checkLocationPermissionRequest(),
    //   this.permissionsService.checkMediaPermissionRequest()
    // ])
  }

  /**
   * Simulate a click at the center of the viewport
   */
  simulateCenterClick() {
    const viewportWidth = Math.max(
      document.documentElement.clientWidth || 0,
      window.innerWidth || 0
    );
    const viewportHeight = Math.max(
      document.documentElement.clientHeight || 0,
      window.innerHeight || 0
    );

    const centerX = Math.floor(viewportWidth / 2);
    const centerY = Math.floor(viewportHeight / 2);

    this.simulateClickAtPoint(centerX, centerY);
  }

  /**
   * Simulate a click at specific coordinates
   */
  simulateClickAtPoint(x: number, y: number) {
    // Create the click event
    const clickEvent = new MouseEvent('click', {
      view: window,
      bubbles: true,
      cancelable: true,
      clientX: x,
      clientY: y,
    });

    // Get element at point
    const element = document.elementFromPoint(x, y);

    if (element) {
      element.dispatchEvent(clickEvent);
    }
  }

  /**
   * Alternative method using Touch events for mobile
   */
  simulateTouchAtCenter() {
    const viewportWidth = Math.max(
      document.documentElement.clientWidth || 0,
      window.innerWidth || 0
    );
    const viewportHeight = Math.max(
      document.documentElement.clientHeight || 0,
      window.innerHeight || 0
    );

    const centerX = Math.floor(viewportWidth / 2);
    const centerY = Math.floor(viewportHeight / 2);

    const touchStart = new Touch({
      identifier: Date.now(),
      target: document.body,
      clientX: centerX,
      clientY: centerY,
      radiusX: 2.5,
      radiusY: 2.5,
      rotationAngle: 0,
      force: 1,
    });

    const touchStartEvent = new TouchEvent('touchstart', {
      cancelable: true,
      bubbles: true,
      touches: [touchStart],
      targetTouches: [touchStart],
      changedTouches: [touchStart],
    });

    const touchEndEvent = new TouchEvent('touchend', {
      cancelable: true,
      bubbles: true,
      touches: [],
      targetTouches: [],
      changedTouches: [touchStart],
    });

    const element = document.elementFromPoint(centerX, centerY);
    if (element) {
      element.dispatchEvent(touchStartEvent);
      setTimeout(() => {
        element.dispatchEvent(touchEndEvent);
      }, 50);
    }
  }

  private setupConnectionHandlers() {
    // // Handle app going to background/foreground
    this.platform.resume.subscribe(() => {
      console.log('App resumed, reconnecting WebSocket');
      this.playerHomeActions.initWebsocketActions();
      // this.websocketActions.configure();
      // MessageDisplayUtil.showMessageToast('App resumed', this.platform, this.toastCtl,
      // 3000, 'top')
    });

    // Handle online/offline status
    window.addEventListener('online', () => {
      console.log('Network connection restored, reconnecting WebSocket');
      this.playerHomeActions.initWebsocketActions();
      this.websocketActions.configure();
      MessageDisplayUtil.showMessageToast(
        'Network connection restored',
        this.platform,
        this.toastCtl,
        3000,
        'top'
      );
    });

    window.addEventListener('offline', () => {
      console.log('Network connection lost');
      MessageDisplayUtil.showErrorToast(
        'Network connection lost',
        this.platform,
        this.toastCtl,
        3000,
        'top'
      );
      // this.connectionStatus.next(false);
    });
  }
}
